// Global Components
import * as React from 'react';

// Components
import InputLabel from '../InputLabel';

// Types
import type {
  $InputProps,
} from '../../../types';

type $OptionalProps = {
  className?: string;
  disabled?: boolean;
  label?: string;
  labelClassName?: string;
  onChange?: (value: string) => unknown;
  placeholder?: string;
  required?: boolean;
  rows?: number;
  value?: null | string;
};

type $Props = $InputProps & $OptionalProps & {
  highlight: boolean;
  name: string;
};

class InputTextareaView extends React.Component<$Props> {
  static defaultProps: $OptionalProps = {
    className: undefined,
    disabled: undefined,
    label: undefined,
    labelClassName: undefined,
    onChange: undefined,
    placeholder: undefined,
    required: undefined,
    rows: undefined,
    value: undefined,
  };

  getClassName(): string {
    const {
      disabled,
      highlight,
      isValid,
    } = this.props;

    return `border-${highlight && !isValid ? 'red-600' : 'gray-400'} ${disabled ? 'bg-gray-200' : ''} text-sm sm:text-base placeholder-gray-600 p-2 rounded-lg border w-full focus:outline-none focus:border-blue-400`;
  }

  renderInput() {
    const {
      disabled,
      name,
      onChange,
      placeholder,
      required,
      rows,
      setValue,
      value,
    } = this.props;

    return (
      <textarea
        autoComplete={'new-password'}
        className={this.getClassName()}
        disabled={disabled}
        id={name}
        name={name}
        onChange={(e) => {
          const newValue = e.currentTarget.value;

          if (onChange) {
            onChange(newValue);
          }

          setValue(newValue);
        }}
        placeholder={placeholder}
        required={required}
        rows={rows || 4}
        value={value || undefined}
      />
    );
  }

  render() {
    const {
      className,
      label,
      labelClassName,
      name,
      required,
    } = this.props;

    return (
      <div className={`InputText ${className || ''}`}>
        <InputLabel
          className={labelClassName}
          label={label}
          name={name}
          required={required}
        />
        {this.renderInput()}
      </div>
    );
  }
}

export default InputTextareaView;
